import { render, staticRenderFns } from "./AdInsights.vue?vue&type=template&id=21561438&scoped=true&"
import script from "./AdInsights.vue?vue&type=script&lang=js&"
export * from "./AdInsights.vue?vue&type=script&lang=js&"
import style0 from "./AdInsights.vue?vue&type=style&index=0&id=21561438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21561438",
  null
  
)

export default component.exports